import styled from 'styled-components';
import { em, rem } from 'styles';

export const Term = styled.span`
  text-decoration: underline dotted currentColor;
  text-decoration-thickness: 1.5px;
  text-underline-offset: 3px;
  cursor: help;
`;

export const Tip = styled.div`
  position: fixed;
  z-index: 9999;
  max-width: ${em(280)};
  padding: ${em(8)} ${em(10)};
  font-size: ${rem(13)};
  font-weight: 400;
  line-height: 1.4;
  color: #fff;
  background: #2b2a26;
  border-radius: ${em(6)};
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  pointer-events: none;
`;
